<template>
  <BaseButtonCircle>
    <img :src="require(`@/assets/img/arrow-${direction}.svg`)"/>
  </BaseButtonCircle>
</template>

<script>
import BaseButtonCircle from '@/components/BaseButtonCircle/BaseButtonCircle'
export default {
  components: {
    BaseButtonCircle
  },
  props: {
    direction: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
img {
  height: 30%;
  width: auto;
  display: block;
}
</style>
